<template>
  <v-main class="main">
    <loader :loading="$auth.loading || appLoading" />
    <v-container class="main-container" :fluid="$route.meta.fluid === true">
      <v-row>
        <v-col>
          <slot />
        </v-col>
      </v-row>
    </v-container>
    <snackbars-container />
  </v-main>
</template>

<script>
import Loader from "@/components/base/Loader.vue";
import SnackbarsContainer from "@/components/snackbar/SnackbarsContainer.vue";

export default {
  name: "Default",
  components: {
    SnackbarsContainer,
    Loader,
  },
  props: {
    appLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: $preston-color-light-grey;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .main-container {
    min-height: 0;
    padding: 16px;
  }
}
</style>
